import { call, put } from 'redux-saga/effects';
import addFilterQueryWithCondition from '../../../utils/addFilterQueryWithCondition';
import { BACKEND_URL } from '../../../configs';
import makeRequest from '../../../utils/makeRequest';
import { OK } from '../../../configs/serverStatusCodes';
import { exportZonesFailed, exportZonesSuccessful } from '../actions';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import processError from '../../../utils/processError';

export default function* exportZones(action) {
  try {
    const filter = action.payload;
    let pool = {};
    if (typeof filter === 'object' && Object.keys(filter).length) {
      pool = addFilterQueryWithCondition(filter, pool);
    }
    const url = `${BACKEND_URL}/zones/export/`;
    const dataResponse = yield makeRequest(url, pool, action, 'GET', true);
    if (dataResponse.status === OK) {
      const data = yield dataResponse.blob();

      const header = dataResponse.headers.get('content-disposition');
      let filename = 'downloaded_file.json';
      if (header && header.includes('filename=')) {
        const matches = header.match(/filename\*=UTF-8''(.+)|filename="?(.+?)"?$/);
        if (matches) {
          filename = decodeURIComponent(matches[1] || matches[2]);
        }
      }
      data.filename = filename;
      yield put(exportZonesSuccessful());
      yield call(resolveActionPromise(action, data));
    } else {
      yield put(exportZonesFailed());
      yield call(rejectActionPromise(action));
    }
  } catch (e) {
    yield put(exportZonesFailed());
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  } finally {
    yield call(resolveActionPromise(action));
  }
}
